$(window).on('load', function () {

  let tagsList = querySelAll('.tags');
  let TAGS_LIMIT_SHOW_MORE = 3;

  function createTagsList() {

    function createTagMoreBtn(count) {
      const tag = document.createElement("div");
      tag.classList.add('tag', 'tags-more');
      tag.textContent = '+' + count
      return tag
    }

    document.body.addEventListener( 'click', function ( event ) {
      if( event.target.classList.contains('tags-more') ) {
        event.target.closest('.tags').classList.add('show-all');
      }
    } );

    tagsList.forEach((item) => {
      const tagListItems = item.querySelectorAll('.tag');
      const tagListLength = tagListItems.length;
      const tagListAdditionalLength = tagListLength - TAGS_LIMIT_SHOW_MORE;

      if (tagListLength > TAGS_LIMIT_SHOW_MORE) {
        item.append(createTagMoreBtn(tagListAdditionalLength))
      }
    });
  }

  if (tagsList.length > 0) {
    createTagsList();
  }

  Marquee3k.init({
    selector: 'marquee3k-intro', // define a custom classname
  });

  $('[data-fancybox]').fancybox({
    video: {
      tpl:
        '<video class="fancybox-video" controls controlsList="nodownload" muted loop playsinline>' +
        '<source src="{{src}}" type="{{format}}" />' +
        'Unfortunately, your browser does not support embedded videos, <a href="{{src}}">download</a> and watch embedded videos with your favorite video player!' +
        "</video>",
      autoStart: true,
    },
    autoFocus: false,
    touch: false,
    loop: true,
  });

  // HEADER START
  const openedMenuClassName = 'hovered';
  const headerSection = querySel('.header-section');
  const headerReturnBtn = querySel('.header__return');
  const submenus = querySelAll('.menu-item-has-children a');
  const linkWithoutMenu = querySelAll('.main-menu li:not(.menu-item-has-children)');
  const menuBurger = querySel('.tog-nav');

  function querySel(el) { return document.querySelector(el) }
  function querySelAll(el) { return document.querySelectorAll(el) }
  function removeHoverFromActiveHeaderSubmenu() {
    querySelAll(`.header-submenu-wrap`).forEach((item) => {
      item.classList.remove('show');
    });
    headerSection.classList.remove('submenu-opened');
    document.querySelector('html').classList.remove('hidden');
  }

  if (headerSection) {
    menuBurger.addEventListener('click', function (e) {
      headerSection.classList.toggle(openedMenuClassName);
      document.querySelector('html').classList.toggle('hidden');
      removeHoverFromActiveHeaderSubmenu();
    });

    headerReturnBtn.addEventListener('click', function (e) {
      removeHoverFromActiveHeaderSubmenu();
    });

    headerSection.addEventListener('mouseleave', function (e) {
      removeHoverFromActiveHeaderSubmenu();
      headerSection.classList.remove('hovered');
    });

    linkWithoutMenu.forEach((item) => {
      item.addEventListener('mouseover', function () { removeHoverFromActiveHeaderSubmenu() });
    })

    submenus.forEach((item) => {
      item.addEventListener('click', function (e) {
        const subMenuName = e.target.innerText.toLowerCase();

        removeHoverFromActiveHeaderSubmenu();
        headerSection.classList.add(openedMenuClassName);
        headerSection.classList.add('submenu-opened');
        querySel(`[data-submenu="${subMenuName}"]`).classList.add('show');
      });
    })
  }

  // HEADER END

  let defaultLogosState = document.querySelector('.default-state');
  let newLogosState = document.querySelector('.new-state');

  function toggleLogos() {
    if (defaultLogosState && newLogosState) {
      defaultLogosState.style.opacity = '0'; // Hide initial logos
      newLogosState.style.opacity = '1'; // Show new logos with smooth opacity transition

      setTimeout(() => {
        defaultLogosState.style.opacity = '1'; // Show initial logos
        newLogosState.style.opacity = '0'; // Hide new logos with smooth opacity transition
      }, 4000); // Revert back after 4 seconds
    }
  }

  // logos
  if (defaultLogosState && newLogosState) {
    setInterval(toggleLogos, 8000); // Start the animation in an infinite loop every 8 seconds
    toggleLogos(); // Start the animation
  }
  // logos

// UTM parameters
  const allowedParams = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];

// Function to set a value in a cookie
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

// Function to extract UTM parameter values from the URL and set them in cookies
  function saveUTMCookies() {
    const parser = new URLSearchParams(window.location.search);

    // Loop through UTM parameters and save them in cookies if present in the URL
    allowedParams.forEach(param => {
      const paramValue = parser.get(param);
      if (paramValue) {
        setCookie(param, paramValue, 30); // 30 days (you can change the expiration period as needed)
      }
    });
  }

// Function to get a value from a cookie
  function getCookie(name) {
    const cookies = document.cookie.split(';')
      .map(cookie => cookie.split('='))
      .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
    return cookies[name];
  }

// Function to get URL parameters and fill form inputs
  function getParams() {
    const parser = new URLSearchParams(window.location.search);

    // Loop through allowedParams and get the value from URL or cookie
    const params = {};
    allowedParams.forEach(param => {
      const paramValue = parser.get(param) || getCookie(param);
      if (paramValue) {
        params[param] = paramValue;
      }
    });

    // Get form inputs and fill them with params
    document.querySelectorAll('.contact-us__form').forEach(form => {
      const wpcf7Form = form.querySelector('.wpcf7-form');
      if (wpcf7Form) {
        const wpcf7FormInputs = wpcf7Form.querySelectorAll(`input[type="hidden"]`);
        let wpcf7FormInputUrl = wpcf7Form.querySelector(`input[name="url"]`);
        let wpcf7FormInputCountry = wpcf7Form.querySelector(`input[name="country"]`);

        if (wpcf7FormInputUrl) {
          wpcf7FormInputUrl.value = window.location.href.split('?')[0];
        }

        if (wpcf7FormInputCountry) {
          const firstServerURL = 'https://api.ipbase.com/v1/json/';
          const secondServerURL = 'https://ipapi.co/json/';

          fetch(firstServerURL)
            .then(response => {
              if (!response.ok) {
                throw new Error('First server - Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              wpcf7FormInputCountry.value = data.country_name;
            })
            .catch(error => {
              fetch(secondServerURL)
                .then(response => {
                  if (!response.ok) {
                    throw new Error('Second server - Network response was not ok');
                  }
                  return response.json();
                })
                .then(data => {
                  wpcf7FormInputCountry.value = data.country_name;
                })
                .catch(error => {
                  wpcf7FormInputCountry.value = 'Country not detected';
                });
            });

        }

        wpcf7FormInputs.forEach(input => {
          const inputName = input.getAttribute('name');
          if (params[inputName]) {
            input.value = params[inputName];
          }
        });
      }
    });
  }

  saveUTMCookies();
  getParams();

  // articles list
  const articlesList = document.querySelector('.articles-list-wrap');

  if (articlesList) {
    articlesList.addEventListener('mouseover', (e) => {

      // Get the target
      const target = e.target;
      const targetParent = target.closest('.articles-list');

      if (targetParent) {
        const targetImg = targetParent.querySelector('.articles-list__img');
        targetImg.classList.add('show')

      }
    })

    articlesList.addEventListener('mouseout', (e) => {
      // Get the target
      const target = e.target;
      const targetParent = target.closest('.articles-list');

      if (targetParent) {
        const targetImg = targetParent.querySelector('.articles-list__img');
        targetImg.classList.remove('show')
      }
    })

    articlesList.addEventListener('mousemove', (e) => {

      // Get the target
      const target = e.target;
      const targetParent = target.closest('.articles-list');

      if (targetParent) {
        const targetImg = targetParent.querySelector('.articles-list__img');

        if (targetImg) {
          const targetImgWidth = targetImg.clientWidth / 2;
          const targetImgHeight = targetImg.clientHeight / 2;
          // Get the bounding client
          const rect = targetParent.getBoundingClientRect();

          // Get X & Y coordinates
          let xPos = e.clientX - rect.left - targetImgWidth;
          let yPos = e.clientY - rect.top - targetImgHeight;

          targetImg.style.left = `${xPos}px`;
          targetImg.style.top = `${yPos}px`;
        }

      }

    })
  }

  const ANCHORS_NAME = 'article_nav_anchor_';
  const NAV_ITEMS_COUNT = querySel('.privacy') ? 20 : 7;
  const navLiWrapper = document.querySelector(".article-nav__items ul");
  let scrolledEl =  Array.from(querySelAll('.text-article > h2')).slice(0, NAV_ITEMS_COUNT);

  if (navLiWrapper && !navLiWrapper.classList.contains('custom-nav')) {
    scrolledEl.forEach(function (element, index) {
      element.setAttribute('id', ANCHORS_NAME + index);
      if (element.textContent) {
        navLiWrapper.insertAdjacentHTML('beforeend',
          `<li><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4 12a1 1 0 01-.293.707l-4.8 4.8a1 1 0 01-1.414-1.414L12.986 12 8.893 7.907a1 1 0 111.414-1.414l4.8 4.8A1 1 0 0115.4 12z" fill="#000"/></svg><a href="#${ANCHORS_NAME + index}" class="article-nav__item">${element.textContent}</a></li>`);
      }
    });
  } else {
    scrolledEl =  querySelAll('[id^="article_nav_anchor_"]');
  }

  const navLiA =  Array.from(document.querySelectorAll(".article-nav__items li a"));

  // updateProgressBar
  function updateProgressBar() {
    const content = document.querySelector('.article-section .article__content');
    const progressBar = document.getElementById('progress-bar');
    const progressContainer = document.querySelector('.progress-bar-wrap');

    const rect = content.getBoundingClientRect();
    const contentTop = rect.top;
    const contentBottom = rect.bottom;

    const windowHeight = window.innerHeight;
    const scrolled = (windowHeight - contentTop) / (windowHeight + contentBottom - contentTop) * 100;

    progressBar.style.width = scrolled + '%';

    if (contentTop < windowHeight) {
      progressContainer.classList.add('show');
    } else {
      progressContainer.classList.remove('show');
    }
  }

  window.addEventListener('scroll', () => {

    scrolledEl.forEach((section) => {
      if (section.offsetTop < window.scrollY + 90) {
        navLiA.forEach((link) => {
          let listItem = link.closest('li');

          if (listItem) {
            listItem.classList.remove('active');
            if (link.getAttribute('href') == ('#' + section.id)) {
              listItem.classList.add('active');
            }
          }
        });
      }
    });

    const header = document.getElementById("header");

    (window.pageYOffset > 100) ? header.classList.add("sticky") : header.classList.remove("sticky");

    if (document.querySelector('.article-section') && document.getElementById('progress-bar')) {
      updateProgressBar();
    }
  })

    if (document.querySelector('.article-section')) {

      let lastKnownScrollPosition = 0;
      let isModalOpen = false;
      let isScrollingUp = false;

      let timer = setTimeout(() => {
        $.fancybox.open({
          src: '#article-popup',
        });
        isScrollingUp = true;
      }, 30000)

      function handleScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll < lastKnownScrollPosition && !isModalOpen && !isScrollingUp) {
          // Scrolling up, modal window not open and scrolling up not processed yet
          clearTimeout(timer);
          openModal();
          isScrollingUp = true;
        }

        lastKnownScrollPosition = currentScroll;
      }

      function openModal() {
        $.fancybox.open({
          src: '#article-popup',
          afterShow: function () {
            isModalOpen = true;
          },
          afterClose: function () {
            isModalOpen = false;
          }
        });
      }

      window.addEventListener('scroll', handleScroll);
    }

  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

  function recentWorkAnimation() {
    const cont = document.querySelector("#panels-container");
    const panels = gsap.utils.toArray("#panels-container .recent-work-item");

    if (cont && panels.length > 0) {
      const tween = gsap.to(panels, {
        x: () => -1 * (cont.scrollWidth - window.innerWidth + 28),
        ease: 'none',
        scrollTrigger: {
          trigger: "#panels-container",
          pin: true,
          start: "top top",
          scrub: 1,
          end: () => "+=" + (cont.scrollWidth - window.innerWidth + 28),
        },
      });
    }
  }

  function parallaxEffect() {
    const cardBlocks = gsap.utils.toArray('.parallax-cards');

    cardBlocks.forEach((block) => {
      const cards = block.querySelectorAll('.parallax-card');
      cards.forEach((card, index) => {
        const direction = index % 2 === 0 ? 1 : -1;
        gsap.to(card, {
          y: () => direction * 30,
          ease: 'none',
          scrollTrigger: {
            trigger: card,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            markers: false,
          },
        });
      });
    });
  }

  recentWorkAnimation();
  parallaxEffect();


  // Tabs
  const allTabs = document.querySelectorAll('.tabs');

  function createTabs() {
    allTabs.forEach(tab => {
      const tabsContainer = tab.querySelector('.tabs-container');
      const tabsHeaderItemsSel = '.tab-header';
      const tabsHeaderItems = Array.from(tab.querySelectorAll(tabsHeaderItemsSel));
      let tabsBodyItems = Array.from(tab.querySelectorAll('.tab-content'));

      if ($(window).width() < 1024) {
        if (tabsContainer.classList.contains('tabsMobile')) {
          tabsBodyItems = Array.from(tab.querySelectorAll('.tab-content-mob'));
        }
      }

      hideTabContent();
      showTabContent();

      tabsContainer.addEventListener('click', (e) => {
        const target = e.target;
        const targetParent = target.closest(tabsHeaderItemsSel);

        if (targetParent) {
          tabsHeaderItems.forEach((item, i) => {
            if (item.classList.contains('active')) {
              hideTabContent();
              return;
            }
            if (targetParent == item) {
              hideTabContent();
              showTabContent(i);
              const y = tabsHeaderItems[i].getBoundingClientRect().top + window.pageYOffset - 90;
              window.scrollTo({top: y});
            }
          });
        }
      });

      function hideTabContent() {
        if(tabsBodyItems.length > 0) {
          tabsBodyItems.forEach(item => {
            item.classList.remove('active');
          });

          tabsHeaderItems.forEach(item => {
            item.classList.remove('active');
          })
        }
      }

      function showTabContent(i = 0) {

        if(tabsBodyItems.length > 0) {
          tabsBodyItems[i].classList.add('active');
          tabsHeaderItems[i].classList.add('active');
        }
      }
    })
  }

  if (allTabs.length > 0) {
    createTabs();
  }

  // AUTO SCROLL IN ARCHIVE PAGES
  function auto_scroll_archives (section, distance) {
    const currentUrl = window.location.href;
    const scrolledUrls = ['/cases/page/', '/case_tag/', '/blog/page/', '/blog_tag/', '/news/page/', '/news_tag/'];
    const shouldScroll = scrolledUrls.some(url => currentUrl.includes(url));

    const urlParams = new URLSearchParams(window.location.search);
    const scrollToAll = urlParams.has('all');
    const searchQuery = urlParams.get('s');

    if (shouldScroll || scrollToAll || (searchQuery !== null)) {
      const targetElement = document.querySelector(section);
      if (targetElement) {
        const targetOffset = targetElement.getBoundingClientRect().top;
        const scrollToPosition = window.scrollY + targetOffset - distance;

        window.scrollTo({top: scrollToPosition, behavior: 'smooth'});
      }
    }
  }

  if (document.querySelector('.cases-list-section')) {
    auto_scroll_archives('.cases-list-section', 80)
  }

  if (document.querySelector('.blog-section')) {
    auto_scroll_archives('.blog-section', 300)
  }

  if (document.querySelector('.news-section')) {
    auto_scroll_archives('.news-section', 80)
  }

  // SLIDERS
  const introSlider = new Swiper('.intro-slider', {
    spaceBetween: 20,
    speed: 300,
    slidesPerView: 1,
    effect: 'fade',
    autoplay: {
      delay: 500,
      disableOnInteraction: false,
    },
  });

  function addZeros(item) {
    return item < 10 ? ('0' + item).slice(-2) : item;
  }

  const testimonials = new Swiper('.testimonials-slider', {
    speed: 700,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 28,
    autoHeight: true,
    pagination: {
      el: '.testimonials-pagination',
      type: 'fraction',
      formatFractionCurrent: (item) => addZeros(item),
      formatFractionTotal: (item) => addZeros(item),
    },
    navigation: {
      prevEl: '.testimonials-prev',
      nextEl: '.testimonials-next',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 28,
      },
      1024: {
        slidesPerView: 1.5,
        spaceBetween: 28,
      },
    }
  });

  const newsFeatured = new Swiper('.news-featured-slider', {
    speed: 700,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 28,
    autoHeight: true,
    pagination: {
      el: '.news-featured-pagination',
      type: 'fraction',
      formatFractionCurrent: (item) => addZeros(item),
      formatFractionTotal: (item) => addZeros(item),
    },
    navigation: {
      prevEl: '.news-featured-prev',
      nextEl: '.news-featured-next',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1200: {
        slidesPerView: 1.5,
        spaceBetween: 28,
      },
    }
  });

  // Set min slide height
  const testimonialsSlides = document.querySelectorAll('.testimonials-slider-wrap .swiper-slide');
  let maxTestimonialsHeight = 0;

  testimonialsSlides.forEach(slide => {
    const testimonial = slide.querySelector('.testimonials-item');
    const testimonialHeight = testimonial.offsetHeight;

    if (testimonialHeight > maxTestimonialsHeight) {
      maxTestimonialsHeight = testimonialHeight;
    }
  });

  testimonialsSlides.forEach(slide => {
    const testimonial = slide.querySelector('.testimonials-item');
    testimonial.style.minHeight = `${maxTestimonialsHeight}px`;
  });

  const howToDo = new Swiper('.how-to-do-slider', {
    speed: 400,
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 48,
    freeMode: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.6,
        spaceBetween: 48,
      },
      1200: {
        slidesPerView: 3.6,
        spaceBetween: 60,
      },
      1440: {
        slidesPerView: 4.3,
        spaceBetween: 80,
      },
    }
  });

  const footerMenuWrap = $('.footer__menu-wrap');
  const footerMenu = $('.footer__menu');
  const footerMenuTitle = footerMenuWrap.find('.footer__title');

  if ($(window).width() < 768) {
    footerMenuTitle.on('click', function () {
      let ths = $(this);

      function closeOthers() {
        footerMenu.not(ths).slideUp();
        footerMenuWrap.not(ths).removeClass('opened');
      }

      if (ths.closest(footerMenuWrap).hasClass('opened')) {
        closeOthers()
        ths.next(footerMenu).slideUp();
        ths.closest(footerMenuWrap).removeClass('opened');
      } else {
        closeOthers();
        ths.next(footerMenu).slideDown();
        ths.closest(footerMenuWrap).addClass('opened');
      }

    });
  }

  // forms
  $(".wpcf7-form").on('wpcf7submit', function (event) {
    // Status "mail_sent" means, that the form submit is complete.
    if ('mail_sent' === event.detail.status) {
      window.dataLayer.push({
        'event': 'lead'
      });
      $.fancybox.close();
      $.fancybox.open({
        src: '#modal-thanks',
      });
    }
  });

  $('.form_popup-close').on('click', function () {
    if (document.querySelector('.article-section')) {
      $.fancybox.close({
        src: '#article-popup',
      });
    }
    $.fancybox.close();
  })

})



